import { axiosInstance } from '../../../common/axiosInstans';
import { DrugSynonym } from '../../../application/types/drug';
import {
    CreateDrugSynonymRequest,
    UpdateDrugSynonymRequest,
    SetAllowSynonymsRequest,
} from '../../../application/types/requests/drugSynonymRequests';

class DrugSynonymService {
    async getSynonyms(drugId: string): Promise<DrugSynonym[]> {
        try {
            const { data } = await axiosInstance.get(`/drugsynonyms/${drugId}`);
            return data;
        } catch (error) {
            console.error('Error getting drug synonyms:', error);
            throw error;
        }
    }

    async createSynonym(
        request: CreateDrugSynonymRequest
    ): Promise<DrugSynonym> {
        try {
            const { data } = await axiosInstance.post('/drugsynonyms', request);
            return data;
        } catch (error) {
            console.error('Error creating drug synonym:', error);
            throw error;
        }
    }

    async updateSynonym(
        id: string,
        request: UpdateDrugSynonymRequest
    ): Promise<DrugSynonym> {
        try {
            const { data } = await axiosInstance.put(
                `/drugsynonyms/${id}`,
                request
            );
            return data;
        } catch (error) {
            console.error('Error updating drug synonym:', error);
            throw error;
        }
    }

    async deleteSynonym(id: string): Promise<void> {
        try {
            await axiosInstance.delete(`/drugsynonyms/${id}`);
        } catch (error) {
            console.error('Error deleting drug synonym:', error);
            throw error;
        }
    }

    async setAllowSynonyms(
        drugId: string,
        allowSynonyms: boolean
    ): Promise<void> {
        try {
            const request: SetAllowSynonymsRequest = {
                drugId,
                allowSynonyms,
            };
            await axiosInstance.put(`/drugsynonyms/allow/${drugId}`, request);
        } catch (error) {
            console.error('Error setting allow synonyms:', error);
            throw error;
        }
    }
}

export default new DrugSynonymService();
